import { render, staticRenderFns } from "./retailers-upload-images-button.vue?vue&type=template&id=19bda0a9&"
import script from "./retailers-upload-images-button.vue?vue&type=script&lang=js&"
export * from "./retailers-upload-images-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports